import * as React from "react";
import * as SC from "./styles";

export default ({ phone }) => {
  if (!phone) {
    return "-";
  }
  return <SC.ATag href={`tel:${phone}`}>{phone}</SC.ATag>;
};
